import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Folder } from 'src/app/models/server/folder';
import { FolderSelectorComponent } from '../../../controls/folder-selector/folder-selector.component';
import { DialogSaveTchatData } from './models/dialog-save-tchat-data';

@Component({
    selector: 'app-save-tchat',
    templateUrl: './save-tchat.component.html',
    styleUrls: ['./save-tchat.component.scss'],
    imports: [MatCardModule, FolderSelectorComponent, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatDialogClose]
})
export class SaveTchatComponent {
    /**
     * Champs du formulaire de saisie de l'intitulé.
     */
    public titleFormControl = new UntypedFormControl(null, [Validators.required]);

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<SaveTchatComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSaveTchatData
    ) {
        this.data = { viewId: null, folderId: null, title: null };
    }

    /**
     * Appelée lorsque l'utilisateur sélectionne un dossier.
     * @param folder : dossier selectionné.
     */
    public onSelected(folder: Folder): void {
        this.data.folderId = folder.id;
        this.data.viewId = folder.viewId;
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}
